import { render, staticRenderFns } from "./ContentItems.vue?vue&type=template&id=35f4c0fe&"
import script from "./ContentItems.vue?vue&type=script&lang=js&"
export * from "./ContentItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports